import 'vanilla-cookieconsent';

// Cookie consent banner (Orest Bida CookieConsent v2 via npm) wired to Google Consent Mode v2.
// The page <head> sets gtag consent defaults to denied before GTM loads; this module applies the
// visitor's stored/changed preferences. The npm build does not inject its own stylesheet; the dist
// base CSS plus the eHUB brand override are bundled globally via css/vendor/_cookieconsent.scss
// (@imported in main.scss).

function updateConsent(level) {
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }

  const state = (category) => level.includes(category) ? 'granted' : 'denied';

  gtag('consent', 'update', {
    ad_storage: state('marketing'),
    ad_user_data: state('marketing'),
    ad_personalization: state('marketing'),
    analytics_storage: state('analytics'),
    functionality_storage: 'granted',
  });
}

function getLang() {
  const match = window.location.pathname.match(/^\/(de|en|hu|pl|ro|sk)(\/|$)/);
  return match ? match[1] : "cs";
}


window.addEventListener('load', function(){
  const cc = initCookieConsent();

  cc.run({
    current_lang: getLang(),
    autoclear_cookies: true,
    page_scripts: true,
    cookie_expiration: 364,
    cookie_necessary_only_expiration: 182,

    // onAccept fires on the first action and on every later page load with a valid cookie;
    // onChange fires when the visitor edits their choice afterwards. Together they keep the
    // Consent Mode v2 signals in sync without a redundant onFirstAction push.
    onAccept: function (cookie) {
      updateConsent(cookie.level)
    },

    onChange: function (cookie, changed_categories) {
      updateConsent(cookie.level)
    },

    languages: {
      'en': {
        consent_modal: {
          title: 'We use cookies! 🍪',
          description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
          primary_btn: {
            text: 'Accept all',
            role: 'accept_all'
          },
          secondary_btn: {
            text: 'Reject all',
            role: 'accept_necessary'
          }
        },
        settings_modal: {
          title: 'Cookie preferences',
          save_settings_btn: 'Save settings',
          accept_all_btn: 'Accept all',
          reject_all_btn: 'Reject all',
          close_btn_label: 'Close',
          cookie_table_headers: [
            { col1: 'Name'},
            { col2: 'Domain'},
            { col3: 'Expiration'},
            { col4: 'Description'}
          ],
          blocks: [
            {
              title: 'Cookie usage 📢',
              description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="https://ehub.cz/en/terms-and-conditions" class="cc-link">privacy policy</a>.'
            }, {
              title: 'Strictly necessary cookies',
              description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true
              }
            }, {
              title: 'Performance and Analytics cookies',
              description: 'These cookies help us track the number of visitors to our website, where visitors come from and how they move around the site. All information collected by these cookies is aggregated and anonymous. We use them to improve the site.',
              toggle: {
                value: 'analytics',
                enabled: true,
                readonly: false
              },
              cookie_table: [
                {
                  col1: '^_ga',
                  col2: 'google.com',
                  col3: '2 years',
                  col4: '',
                  is_regex: true
                },
                {
                  col1: '_gid',
                  col2: 'google.com',
                  col3: '1 day',
                  col4: '',
                }
              ]
            }, {
              title: 'Advertisement and Targeting cookies',
              description: 'These cookies are managed by Facebook. We use them to target and evaluate advertising on Facebook and on sites participating in the Facebook advertising platform. They do not store your personal information directly, but via unique browser and internet device identifiers.',
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }, {
              title: 'More information',
              description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/en/contact">contact us</a>.',
            }
          ]
        }
      },
      'cs': {
        consent_modal: {
          title: 'Používáme cookies! 🍪',
          description: '' +
            'K provozování těchto webových stránek a zajištění personalizovanějšího uživatelského zážitku affiliate síť eHUB potřebuje váš souhlas se zpracováním cookie souborů - malé soubory, které se dočasně ukládají ve vašem prohlížeči. <button type="button" data-cc="c-settings" class="cc-link">Přizpůsobit cookies</button>',
          primary_btn: {
            text: 'Příjmout vše',
            role: 'accept_all'
          },
          secondary_btn: {
            text: 'Nepovolit',
            role: 'accept_necessary'
          }
        },
        settings_modal: {
          title: 'Nastavení cookies',
          save_settings_btn: 'Uložit',
          accept_all_btn: 'Příjmout vše',
          reject_all_btn: 'Nepovolit',
          close_btn_label: 'Zavřít',
          cookie_table_headers: [
            { col1: 'Name'},
            { col2: 'Domain'},
            { col3: 'Expiration'},
            { col4: 'Description'}
          ],
          blocks: [
            {
              title: 'Výběr cookies 📢',
              description: 'K provozování těchto webových stránek a zajištění personalizovanějšího uživatelského zážitku affiliate síť eHUB potřebuje váš souhlas se zpracováním cookie souborů - malé soubory, které se dočasně ukládají ve vašem prohlížeči. <a href="https://ehub.cz/obchodni-podminky" class="cc-link">Obchodní podmínky</a>.'
            }, {
              title: 'Funkčně nezbytné cookies',
              description: 'Tyto cookies jsou nezbytné pro fungování těchto stránek. Bez nich by stránky správně nefungovaly.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true
              }
            }, {
              title: 'Analytické cookies',
              description: 'Pomáhají nám sledovat počet návštěvníků na našem webu, odkud návštěvníci přicházejí a jak se na webu pohybují. Všechny informace, které tyto cookies shromažďují, jsou souhrnné a anonymní. Vužíváme je k vylepšování webu.',
              toggle: {
                value: 'analytics',
                enabled: true,
                readonly: false
              },
              cookie_table: [
                {
                  col1: '^_ga',
                  col2: 'google.com',
                  col3: '2 years',
                  col4: '',
                  is_regex: true
                },
                {
                  col1: '_gid',
                  col2: 'google.com',
                  col3: '1 day',
                  col4: '',
                }
              ]
            }, {
              title: 'Marketingové cookies',
              description: 'Tyto cookies spravuje společnost Facebook. Používáme je pro cílení a vyhodnocování reklamy na Facebooku a na webech zapojených do reklamní platformy Facebook. Neukládají vaše osobní informace přímo, ale přes jedinečné identifikátory prohlížeče a internetového zařízení.',
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }, {
              title: 'Více informací',
              description: 'Pokud máte jakékoliv dotazy, prosím, <a class="cc-link" href="/kontakt">obraťte se na nás</a>.',
            }
          ]
        }
      },
      'sk': {
        consent_modal: {
          title: 'Používame cookies! 🍪',
          description: '' +
            'Na prevádzkovanie týchto webových stránok a zaistenie personalizovanejšieho používateľského zážitku affiliate sieť eHUB potrebuje váš súhlas so spracovaním cookie súborov – malé súbory, ktoré sa dočasne ukladajú vo vašom prehliadači. <button type="button" data-cc="c-settings" class="cc-link">Prispôsobiť cookies</button>',
          primary_btn: {
            text: 'Prijať všetko',
            role: 'accept_all'
          },
          secondary_btn: {
            text: 'Nepovoliť',
            role: 'accept_necessary'
          }
        },
        settings_modal: {
          title: 'Nastavenie cookies',
          save_settings_btn: 'Uložiť',
          accept_all_btn: 'Prijať všetko',
          reject_all_btn: 'Nepovoliť',
          close_btn_label: 'Zavrieť',
          cookie_table_headers: [
            { col1: 'Name'},
            { col2: 'Domain'},
            { col3: 'Expiration'},
            { col4: 'Description'}
          ],
          blocks: [
            {
              title: 'Výber cookies 📢',
              description: 'Na prevádzkovanie týchto webových stránok a zabezpečenie personalizovanejšieho používateľského zážitku potrebuje affiliate sieť eHUB váš súhlas so spracovaním cookie súborov – malých súborov, ktoré sa dočasne ukladajú vo vašom prehliadači. <a href="https://ehub.cz/obchodni-podminky" class="cc-link">Obchodné podmienky</a>.'
            }, {
              title: 'Funkčne nevyhnutné cookies',
              description: 'Tieto cookies sú nevyhnutné pre fungovanie týchto stránok. Bez nich by stránky správne nefungovali.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true
              }
            }, {
              title: 'Analytické cookies',
              description: 'Pomáhajú nám sledovať počet návštevníkov na našom webe, odkiaľ prichádzajú a ako sa na ňom pohybujú. Všetky informácie, ktoré tieto cookies zhromažďujú, sú súhrnné a anonymné. Používame ich na vylepšovanie webu.',
              toggle: {
                value: 'analytics',
                enabled: true,
                readonly: false
              },
              cookie_table: [
                {
                  col1: '^_ga',
                  col2: 'google.com',
                  col3: '2 years',
                  col4: '',
                  is_regex: true
                },
                {
                  col1: '_gid',
                  col2: 'google.com',
                  col3: '1 day',
                  col4: '',
                }
              ]
            }, {
              title: 'Marketingové cookies',
              description: 'Tieto cookies spravuje spoločnosť Facebook. Používame ich na zacielenie a vyhodnocovanie reklamy na Facebooku a na weboch zapojených do reklamnej platformy Facebook. Neukladajú vaše osobné informácie priamo, ale cez jedinečné identifikátory prehliadača a zariadenia.',
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }, {
              title: 'Viac informácií',
              description: 'Ak máte akékoľvek otázky, prosím,  <a class="cc-link" href="/kontakt">obráťte sa na nás</a>.',
            }
          ]
        }
      },
      'de': {
        consent_modal: {
          title: 'Wir verwenden Cookies! 🍪',
          description: '' +
            'Um diese Website zu betreiben und ein personalisierteres Benutzererlebnis zu bieten, benötigt das eHUB-Partnernetzwerk Ihre Zustimmung zur Verwendung von Cookies – kleinen Dateien, die vorübergehend in Ihrem Browser gespeichert werden. <button type="button" data-cc="c-settings" class="cc-link">Cookies anpassen</button>',
          primary_btn: {
            text: 'Akzeptiere alles',
            role: 'accept_all'
          },
          secondary_btn: {
            text: 'Nicht zulassen',
            role: 'accept_necessary'
          }
        },
        settings_modal: {
          title: 'Cookie-Einstellungen',
          save_settings_btn: 'Auferlegen',
          accept_all_btn: 'Akzeptiere alles',
          reject_all_btn: 'Nicht zulassen',
          close_btn_label: 'Schließen',
          cookie_table_headers: [
            { col1: 'Name'},
            { col2: 'Domain'},
            { col3: 'Expiration'},
            { col4: 'Description'}
          ],
          blocks: [
            {
              title: 'Cookie-Auswahl 📢',
              description: 'Um diese Website zu betreiben und Ihnen ein personalisierteres Nutzererlebnis zu bieten, benötigt das Partnernetzwerk eHUB Ihre Zustimmung zur Verwendung von Cookies – kleinen Dateien, die vorübergehend in Ihrem Browser gespeichert werden. <a href="https://ehub.cz/en/terms-and-conditions" class="cc-link">AGB</a>.'
            }, {
              title: 'Funktional notwendige Cookies',
              description: 'Diese Cookies sind für das Funktionieren dieser Website notwendig. Ohne sie würde die Seite nicht richtig funktionieren.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true
              }
            }, {
              title: 'Analyse-Cookies',
              description: 'Diese Cookies helfen uns, die Anzahl der Besucher unserer Website zu erfassen, zu sehen, woher sie kommen und wie sie sich auf der Seite bewegen. Alle durch diese Cookies gesammelten Informationen sind zusammengefasst und anonym. Wir verwenden sie, um unsere Website zu verbessern.',
              toggle: {
                value: 'analytics',
                enabled: true,
                readonly: false
              },
              cookie_table: [
                {
                  col1: '^_ga',
                  col2: 'google.com',
                  col3: '2 years',
                  col4: '',
                  is_regex: true
                },
                {
                  col1: '_gid',
                  col2: 'google.com',
                  col3: '1 day',
                  col4: '',
                }
              ]
            }, {
              title: 'Marketing-Cookies',
              description: 'Diese Cookies werden von Facebook verwaltet. Wir nutzen sie, um Werbung auf Facebook und auf Websites innerhalb des Facebook-Werbenetzwerks gezielt einzusetzen und deren Wirksamkeit zu messen. Sie speichern Ihre personenbezogenen Daten nicht direkt, sondern arbeiten mit eindeutigen Kennungen Ihres Browsers und Geräts.',
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }, {
              title: 'Weitere Informationen',
              description: 'Wenn Sie Fragen haben, <a class="cc-link" href="/kontakt">kontaktieren Sie uns bitte</a>.',
            }
          ]
        }
      },
      'pl': {
        consent_modal: {
          title: 'Używamy plików cookie! 🍪',
          description: '' +
            'Aby ta strona działała i zapewniała bardziej spersonalizowane wrażenia użytkownika, sieć afiliacyjna eHUB potrzebuje Twojej zgody na przetwarzanie plików cookie – małych plików, które są tymczasowo przechowywane w Twojej przeglądarce. <button type="button" data-cc="c-settings" class="cc-link">Dostosuj pliki cookie</button>',
          primary_btn: {
            text: 'Zaakceptuj wszystko',
            role: 'accept_all'
          },
          secondary_btn: {
            text: 'Nie pozwalaj',
            role: 'accept_necessary'
          }
        },
        settings_modal: {
          title: 'Ustawienia plików cookie',
          save_settings_btn: 'Narzucać',
          accept_all_btn: 'Zaakceptuj wszystko',
          reject_all_btn: 'Nie pozwalaj',
          close_btn_label: 'Zamknąć',
          cookie_table_headers: [
            { col1: 'Name'},
            { col2: 'Domain'},
            { col3: 'Expiration'},
            { col4: 'Description'}
          ],
          blocks: [
            {
              title: 'Wybór plików cookie 📢',
              description: 'Aby korzystać z tej witryny i zapewnić Ci bardziej spersonalizowane doświadczenie użytkownika, sieć afiliacyjna eHUB potrzebuje Twojej zgody na używanie plików cookie – małych plików tymczasowo zapisywanych w Twojej przeglądarce. <a href="https://ehub.cz/en/terms-and-conditions" class="cc-link">Regulamin</a>.'
            }, {
              title: 'Niezbędne pliki cookie',
              description: 'Te pliki cookie są konieczne do prawidłowego funkcjonowania tej witryny. Bez nich strona nie działałaby poprawnie.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true
              }
            }, {
              title: 'Pliki cookie analityczne',
              description: 'Pomagają nam śledzić liczbę odwiedzających naszą witrynę, skąd pochodzą i w jaki sposób się po niej poruszają. Wszystkie informacje gromadzone przez te pliki cookie są zbiorcze i anonimowe. Wykorzystujemy je do ulepszania naszej witryny.',
              toggle: {
                value: 'analytics',
                enabled: true,
                readonly: false
              },
              cookie_table: [
                {
                  col1: '^_ga',
                  col2: 'google.com',
                  col3: '2 years',
                  col4: '',
                  is_regex: true
                },
                {
                  col1: '_gid',
                  col2: 'google.com',
                  col3: '1 day',
                  col4: '',
                }
              ]
            }, {
              title: 'Pliki cookie marketingowe',
              description: 'Te pliki cookie są zarządzane przez Facebooka. Używamy ich do targetowania i mierzenia skuteczności reklam na Facebooku oraz na stronach wchodzących w skład sieci reklamowej Facebooka. Nie przechowują one bezpośrednio Twoich danych osobowych, lecz działają za pomocą unikalnych identyfikatorów przeglądarki i urządzenia.',
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }, {
              title: 'Więcej informacji',
              description: 'Jeśli masz pytania, <a class="cc-link" href="/kontakt">skontaktuj się z nami</a>.',
            }
          ]
        }
      },
      'hu': {
        consent_modal: {
          title: 'Używamy plików cookie! 🍪',
          description: '' +
            'Aby ta strona działała i zapewniała bardziej spersonalizowane wrażenia użytkownika, sieć afiliacyjna eHUB potrzebuje Twojej zgody na przetwarzanie plików cookie – małych plików, które są tymczasowo przechowywane w Twojej przeglądarce. <button type="button" data-cc="c-settings" class="cc-link">Dostosuj pliki cookie</button>',
          primary_btn: {
            text: 'Elfogadni mindent',
            role: 'accept_all'
          },
          secondary_btn: {
            text: 'Ne engedje meg',
            role: 'accept_necessary'
          }
        },
        settings_modal: {
          title: 'Cookie-beállítások',
          save_settings_btn: 'Kikényszeríteni',
          accept_all_btn: 'Elfogadni mindent',
          reject_all_btn: 'Ne engedje meg',
          close_btn_label: 'Közeli',
          cookie_table_headers: [
            { col1: 'Name'},
            { col2: 'Domain'},
            { col3: 'Expiration'},
            { col4: 'Description'}
          ],
          blocks: [
            {
              title: 'Cookie-beállítások kiválasztása 📢',
              description: 'A weboldal működtetéséhez és a személyre szabottabb felhasználói élmény biztosításához az eHUB affiliate hálózatnak szüksége van az Ön hozzájárulására a cookie-k használatához – ezek kis fájlok, amelyek ideiglenesen a böngészőjében tárolódnak, <a href="https://ehub.cz/en/terms-and-conditions" class="cc-link">Általános Szerződési Feltételek</a>.'
            }, {
              title: 'Feltétlenül szükséges cookie-k',
              description: 'Ezek a cookie-k elengedhetetlenek a weboldal megfelelő működéséhez. Nélkülük az oldal nem működne rendesen.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true
              }
            }, {
              title: 'Analitikai cookie-k',
              description: 'Ezek a cookie-k segítenek nyomon követni a látogatók számát, megérteni, honnan érkeznek, és hogyan navigálnak a weboldalon. Az általuk gyűjtött információk összesítettek és anonimak. A weboldal fejlesztésére használjuk őket.',
              toggle: {
                value: 'analytics',
                enabled: true,
                readonly: false
              },
              cookie_table: [
                {
                  col1: '^_ga',
                  col2: 'google.com',
                  col3: '2 years',
                  col4: '',
                  is_regex: true
                },
                {
                  col1: '_gid',
                  col2: 'google.com',
                  col3: '1 day',
                  col4: '',
                }
              ]
            }, {
              title: 'Marketing cookie-k',
              description: 'Ezeket a cookie-kat a Facebook kezeli. Arra használjuk őket, hogy a Facebookon és a Facebook hirdetési hálózatába tartozó webhelyeken célzottan jelenítsünk meg és mérjünk hirdetéseket. Nem tárolják közvetlenül az Ön személyes adatait, hanem egyedi böngésző- és eszközazonosítókon keresztül működnek.',
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }, {
              title: 'További információ',
              description: 'Ha bármilyen kérdése van, <a class="cc-link" href="/kontakt">forduljon hozzánk</a>.',
            }
          ]
        }
      },
      'ro': {
        consent_modal: {
          title: 'Folosim cookie-uri! 🍪',
          description: '' +
            'Pentru a opera acest site web și a oferi o experiență de utilizare mai personalizată, rețeaua de afiliere eHUB are nevoie de consimțământul dvs. pentru utilizarea cookie-urilor – fișiere mici care sunt stocate temporar în browserul dvs. <button type="button" data-cc="c-settings" class="cc-link">Personalizați cookie-uri</button>',
          primary_btn: {
            text: 'Accepta totul',
            role: 'accept_all'
          },
          secondary_btn: {
            text: 'Nu permiteți',
            role: 'accept_necessary'
          }
        },
        settings_modal: {
          title: 'Setări cookie',
          save_settings_btn: 'Impune',
          accept_all_btn: 'Accepta totul',
          reject_all_btn: 'Nu permiteți',
          close_btn_label: 'Aproape',
          cookie_table_headers: [
            { col1: 'Name'},
            { col2: 'Domain'},
            { col3: 'Expiration'},
            { col4: 'Description'}
          ],
          blocks: [
            {
              title: 'Preferințe cookie 📢',
              description: 'Pentru a funcționa corect și a vă oferi o experiență de utilizator mai personalizată, rețeaua de afiliere eHUB are nevoie de consimțământul dumneavoastră pentru utilizarea cookie-urilor – fișiere mici stocate temporar în browserul dumneavoastră, <a href="https://ehub.cz/en/terms-and-conditions" class="cc-link">Termeni și condiții</a>.'
            }, {
              title: 'Cookie-uri strict necesare',
              description: 'Aceste cookie-uri sunt esențiale pentru funcționarea site-ului. Fără ele, site-ul nu ar funcționa corespunzător.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true
              }
            }, {
              title: 'Cookie-uri analitice',
              description: 'Aceste cookie-uri ne ajută să urmărim numărul vizitatorilor, de unde provin și cum navighează pe site. Toate informațiile colectate sunt agregate și anonime. Le folosim pentru a îmbunătăți site-ul.',
              toggle: {
                value: 'analytics',
                enabled: true,
                readonly: false
              },
              cookie_table: [
                {
                  col1: '^_ga',
                  col2: 'google.com',
                  col3: '2 years',
                  col4: '',
                  is_regex: true
                },
                {
                  col1: '_gid',
                  col2: 'google.com',
                  col3: '1 day',
                  col4: '',
                }
              ]
            }, {
              title: 'Cookie-uri de marketing',
              description: 'Aceste cookie-uri sunt gestionate de Facebook. Le folosim pentru a direcționa și a măsura eficiența reclamelor pe Facebook și pe site-urile din rețeaua publicitară Facebook. Ele nu stochează direct datele dumneavoastră personale, ci funcționează prin identificatori unici ai browserului și dispozitivului.',
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }, {
              title: 'Mai multe informații',
              description: 'Dacă aveți întrebări, vă rugăm să <a class="cc-link" href="/kontakt">ne contactați</a>.',
            }
          ]
        }
      }
    }
  });
});
